export const portfolioData = {
  "website-projects": {
    "slug": "website-projects",
    "title": "Website Projects",
    "heroIcon": "fa-laptop-code",
    "heroBg": "/assets/img/unsplash-1503437313881-503a91226402.jpg",
    "overview": "A showcase of our recent website design and development projects, featuring responsive layouts, custom e-commerce stores, and high-performance corporate platforms.",
    "projects": [
      {
        "title": "Corporate E-Commerce Portal",
        "category": "Web Development",
        "image": "/assets/img/unsplash-1542621334-a254cf47733d.jpg"
      },
      {
        "title": "Real Estate Listing Platform",
        "category": "Web Design & Development",
        "image": "/assets/img/unsplash-1454165804606-c3d57bc86b40.jpg"
      }
    ]
  },
  "mobile-apps": {
    "slug": "mobile-apps",
    "title": "Mobile Apps",
    "heroIcon": "fa-mobile-alt",
    "heroBg": "/assets/img/unsplash-1504384308090-c894fdcc538d.jpg",
    "overview": "Explore our mobile applications developed for iOS and Android, delivering seamless user experiences and robust functionality for businesses on the go.",
    "projects": [
      {
        "title": "On-Demand Delivery App",
        "category": "iOS & Android",
        "image": "/assets/img/unsplash-1503437313881-503a91226402.jpg"
      },
      {
        "title": "Fitness Tracking Platform",
        "category": "React Native",
        "image": "/assets/img/unsplash-1542621334-a254cf47733d.jpg"
      }
    ]
  },
  "software-solutions": {
    "slug": "software-solutions",
    "title": "Software Solutions",
    "heroIcon": "fa-cogs",
    "heroBg": "/assets/img/unsplash-1454165804606-c3d57bc86b40.jpg",
    "overview": "View our custom enterprise software solutions, including CRMs, ERPs, and automated workflow systems designed to streamline business operations.",
    "projects": [
      {
        "title": "Enterprise CRM Dashboard",
        "category": "Custom Software",
        "image": "/assets/img/unsplash-1504384308090-c894fdcc538d.jpg"
      },
      {
        "title": "Automated HR & Payroll System",
        "category": "Enterprise Solutions",
        "image": "/assets/img/unsplash-1503437313881-503a91226402.jpg"
      }
    ]
  }
};
